"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VarnishApp = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var components_1 = require("../components");
var Theme_1 = require("../theme/Theme");
/**
 * A top level container for your application that handles errors cleanly,
 * makes the required theme available to child components, and sets up
 * the application layout.
 *
 * If the theme property is provided, it's deeply merged with the default Varnish
 * theme. Which means you can only provide the properties you'd like to override,
 * and those not provided will use the defaults.
 */
var VarnishApp = function (_a) {
    var layout = _a.layout, theme = _a.theme, children = _a.children;
    var mergedTheme = (0, lodash_merge_1.default)({}, Theme_1.Theme, theme);
    return (React.createElement(styled_components_1.ThemeProvider, { theme: mergedTheme },
        React.createElement(components_1.ErrorBoundary, null,
            React.createElement(components_1.DefaultAppLayoutProvider, { layout: layout || 'center-aligned' }, children))));
};
exports.VarnishApp = VarnishApp;
//# sourceMappingURL=VarnishApp.js.map